import { v4 as uuidv4 } from 'uuid';

class MultiplasService {
  constructor() {
    this.apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';
  }

  async getBestBets(gameData, sport, prompt, userId) {
    const sessionId = uuidv4();

    try {
      const response = await fetch(`${this.apiUrl}/ai/ask`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          question: prompt,
          history: [],
          language: 'en',
          isGuest: false,
          metadata: {
            userId: userId,
            sessionId: sessionId,
            conversationId: sessionId,
            sport: sport,
            gameData: gameData
          }
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let fullResponse = '';
      let actualContent = '';

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value);

        // Parse SSE format (data: {...})
        const lines = chunk.split('\n');
        for (const line of lines) {
          if (line.startsWith('data: ')) {
            try {
              const jsonStr = line.slice(6); // Remove 'data: ' prefix
              if (jsonStr.trim()) {
                const parsed = JSON.parse(jsonStr);
                if (parsed.type === 'content' && parsed.text) {
                  actualContent += parsed.text;
                  if (this.onStream) {
                    this.onStream(parsed.text);
                  }
                }
              }
            } catch (e) {
              // Not JSON, might be plain text
              if (line.slice(6).trim()) {
                actualContent += line.slice(6);
              }
            }
          }
        }

        fullResponse += chunk;
      }

      return actualContent || fullResponse;
    } catch (error) {
      console.error('MultiplasService error:', error);
      throw error;
    }
  }

  setStreamCallback(callback) {
    this.onStream = callback;
  }
}

export default new MultiplasService();